import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { EngagementsSection } from '../components/EngagementsSection';
import { ExecutionScopeSection } from '../components/ExecutionScopeSection';
import { FitFilterSection } from '../components/FitFilterSection';
import { ContactSection } from '../components/ContactSection';
export function LandingPage() {
  return <div className="min-h-screen bg-white text-black font-sans selection:bg-gray-200" data-id="element-142">
      <Header data-id="element-143" />
      <main data-id="element-144">
        <HeroSection data-id="element-145" />
        <AboutSection data-id="element-146" />
        <HowItWorksSection data-id="element-147" />
        <EngagementsSection data-id="element-148" />
        <ExecutionScopeSection data-id="element-149" />
        <FitFilterSection data-id="element-150" />
        <ContactSection data-id="element-151" />
      </main>

      <footer className="py-12 border-t border-gray-100" data-id="element-152">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center text-xs text-gray-400 uppercase tracking-widest" data-id="element-153">
          <p data-id="element-154">&copy; {new Date().getFullYear()} Brittney Gwynn.</p>
        </div>
      </footer>
    </div>;
}